module.exports = __webpack_public_path__ + "static/img/noBinding.645af8c7.png";